import { Component, OnInit, OnDestroy } from '@angular/core';
import { UserService } from '../../../../services/user.service';
import { CurrentUser } from '../../../../models/currentUser.model';
import { ItemTypeService } from '../../services/item-type.service';
import { ItemUserService } from '../../services/item-user.service';
import { Item } from '../../models/item';
import { ItemType } from '../../models/item-type';
import {MatTableDataSource} from '@angular/material';
import { interval } from 'rxjs';
import { ToastrService } from 'ngx-toastr';
import { DisplayException } from '../../../../models/display-exception';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-item-dashboard',
  templateUrl: './item-dashboard.component.html',
  styleUrls: ['./item-dashboard.component.css']
})
export class ItemDashboardComponent implements OnInit, OnDestroy {
  ngOnDestroy(): void {
    clearInterval(this.refreshInterval);
  }

  public currentUser:CurrentUser;
  public lastItem:Item;
  public now:Date;
  public types:ItemType[]
  public availabletypes:ItemType[]
  public dataSource:MatTableDataSource<Item> = null;
  public displayedColumns: string[] = ['state', 'from', 'till', 'duration'];
 
  private refreshInterval = null;
  constructor(
    private translateService: TranslateService,
    private userService:UserService,
    private itemUserService:ItemUserService,
    private itemTypeService:ItemTypeService,    
    private toastrService:ToastrService
    ) { 

    }
    getTypeName(id:string){
      let ret:string = null;
      if(this.types){
        let type = this.types.find(t=>t.id == id);
        if(type){
          ret = type.name;
        }
      }
      return ret;
    }    
    setState(type:ItemType){
      if(type){
        this.itemUserService.AddType(type.id,new Item()).subscribe(res=>{
          console.log('AddType ok',res);
          this.getLastState();
        }, (err)=>{
          console.log('AddType err',err);
          if(err){
            if(err.type === 'FromIsOverlaping')
            this.translateService.get('errors.fromOverlaping').subscribe(fromOverlaping => {
              this.toastrService.error(fromOverlaping);
            })
          }
        });
      }
    }  
    getLastState(){
      this.itemUserService.Last().subscribe(res=>{
        this.now = new Date();
        this.lastItem = res.payload;
        this.itemTypeService.GetAll('order').subscribe(res=>{
          this.types = null;
          if(res && res.payload)
          {
            this.types = res.payload;
            if(this.lastItem){
              this.availabletypes = res.payload.filter(t=>t.id !== this.lastItem.idItemType);
            }
            else {
              this.availabletypes = res.payload;
            }
          }          
          this.itemUserService.GetAll('from','desc',1,5).subscribe(resp=>{
            this.dataSource  = new MatTableDataSource(resp.payload);
          })
        })
      });
    }    
  ngOnInit() {
    this.currentUser = this.userService.current;
    this.getLastState();
    this.refreshInterval = setInterval(()=>{
      this.getLastState();
    },15000)
    
  }
}
